import { render } from "./Copy.vue?vue&type=template&id=0235b9c0"
import script from "./Copy.vue?vue&type=script&lang=js"
export * from "./Copy.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.8.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__